import { render, staticRenderFns } from "./CardOst.vue?vue&type=template&id=25bc35d7"
import script from "./CardOst.vue?vue&type=script&lang=js"
export * from "./CardOst.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports